import pkg from '../../package.json';

export const APP_VERSION = pkg.version;

export const STAGING_DOWNLOAD_ORIGIN = 'https://dl-staging.fokus.plet.ai';
export const PRODUCTION_DOWNLOAD_ORIGIN = 'https://dl.fokus.plet.ai';

/** Auto-update still uses these. People-facing downloads use the versioned file. */
export const STAGING_WINDOWS_INSTALLER_URL = `${STAGING_DOWNLOAD_ORIGIN}/Fokus-Staging-latest.exe`;
export const PRODUCTION_WINDOWS_INSTALLER_URL = `${PRODUCTION_DOWNLOAD_ORIGIN}/Fokus-latest.exe`;

function isProductionDownload({ env, hostname }) {
  return env === 'production' || hostname === 'fokus.plet.ai';
}

export function getDesktopInstallerFileName({
  env = process.env.REACT_APP_ENV,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  version = APP_VERSION,
} = {}) {
  return isProductionDownload({ env, hostname })
    ? `Fokus-${version}.exe`
    : `Fokus-Staging-${version}.exe`;
}

/**
 * Public Windows installer for the current site.
 * Production site → production exe. Everywhere else → staging exe.
 * Filename includes the version so the download is not "Fokus-latest".
 */
export function getDesktopInstallerUrl({
  env = process.env.REACT_APP_ENV,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  version = APP_VERSION,
} = {}) {
  const name = getDesktopInstallerFileName({ env, hostname, version });
  const origin = isProductionDownload({ env, hostname })
    ? PRODUCTION_DOWNLOAD_ORIGIN
    : STAGING_DOWNLOAD_ORIGIN;
  return `${origin}/${name}`;
}

export function isElectronShell() {
  return Boolean(typeof window !== 'undefined' && window.electronAPI?.isElectron);
}
